import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage-angular';

/**
 * Wrapper for ionic storage. Initializes an ionic database to use throughout the app.
 */
@Injectable({
  providedIn: 'root'
})
export class StorageService {
  private _storage: Storage | null = null;

  constructor(private storage: Storage) {
    this.init();
  }

  async init() {
    const storage = await this.storage.create();
    this._storage = storage;
  }

  async set(key: string, value: any) {
    return await this._storage?.set(key, value);
  }

  async get(key: string) {
    return await this.storage.get(key);
  }

  async remove(key: string) {
    return await this.storage.remove(key);
  }

  async clear() {
    return await this.storage.clear();
  }

  async removeMultipleValues(values: string[]) {
    return values.forEach(async (value) => {
      return await this.storage.remove(value);
    });
  }
}
